module.exports = __webpack_public_path__ + "static/media/fearful-face-svgrepo-com.67dffe10.svg";